const PrintContent = ({ colunas, dados, title, subtitle }) => {
  const summary_coluns = [];
  for (let index = 1; index < colunas?.length; index++) {
    let col = 0;
    dados?.forEach((e) => {
      col += parseInt(e?.[colunas[index]?.dataIndex] ?? 0);
    });
    summary_coluns.push(col);
  }

  return (
    <div className="print-container">
      <p className="print-title">{title}</p>
      <p className="print-subtitle">{subtitle}</p>
      <br />
      <table className="print-table table-print-portrait">
        <thead>
          <tr>
            {colunas?.map((col) => {
              return (
                <th key={col?.title} style={{ width: col?.width }}>
                  {col?.title}
                </th>
              );
            })}
          </tr>
        </thead>
        <tbody>
          {dados?.map((row) => (
            <tr key={row?.id}>
              {colunas?.map((col, index) => (
                <td key={index}>{row?.[col?.dataIndex]}</td>
              ))}
            </tr>
          ))}
        </tbody>
        <tfoot>
          <tr>
            <th>Total</th>
            {summary_coluns?.map((e, index) => (
              <th key={index}>{e}</th>
            ))}
          </tr>
        </tfoot>
      </table>
      <br />
    </div>
  );
};

export { PrintContent };
